import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { BrandLogo } from "../context/BrandingContext";
import { apiError } from "../lib/api";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const user = await login(email, password);
      navigate(user.role === "superadmin" ? "/superadmin" : "/");
    } catch (err) {
      setError(apiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-zinc-100 restaurant-area flex items-center justify-center p-4">
      <div className="w-full max-w-sm bg-white border border-zinc-200 rounded-lg p-8">
        <div className="flex justify-center mb-3" data-testid="login-brand">
          <BrandLogo slot="dark" fallbackClass="font-display font-extrabold text-4xl tracking-tight text-zinc-900" className="h-20 w-auto max-w-full object-contain" />
        </div>
        <p className="text-sm text-zinc-500 mb-6 text-center">Gestionale per il tuo ristorante</p>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="text-xs font-semibold uppercase tracking-wider text-zinc-500">Email</label>
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              data-testid="login-email" autoComplete="email"
              className="mt-1 w-full h-11 px-3 rounded-md border border-zinc-300 text-sm focus:outline-none focus:ring-2 focus:ring-zinc-900" />
          </div>
          <div>
            <label className="text-xs font-semibold uppercase tracking-wider text-zinc-500">Password</label>
            <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
              data-testid="login-password" autoComplete="current-password"
              className="mt-1 w-full h-11 px-3 rounded-md border border-zinc-300 text-sm focus:outline-none focus:ring-2 focus:ring-zinc-900" />
          </div>
          {error && <div className="text-sm text-rose-700 bg-rose-50 border border-rose-200 rounded-md px-3 py-2" data-testid="login-error">{error}</div>}
          <button type="submit" disabled={loading} data-testid="login-submit"
            className="w-full h-12 rounded-md bg-zinc-900 text-white font-semibold text-sm hover:bg-zinc-800 active:scale-[0.98] transition disabled:opacity-50">
            {loading ? "Accesso..." : "Accedi"}
          </button>
        </form>
      </div>
    </div>
  );
}
